import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function StampLine({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path d="M4.875 16H19.125C20.1605 16 21 16.8395 21 17.875V20.1429C21 20.6162 20.6162 21 20.1429 21H3.85714C3.38376 21 3 20.6162 3 20.1429V17.875C3 16.8395 3.83947 16 4.875 16Z"
                stroke={color} strokeWidth="2"/>
            <path d="M12 3C14.2087 3.00028 15.9999 4.90101 16 7.24512C16 7.3366 15.9946 7.42753 15.9893 7.51758C15.9426 8.41935 15.6756 8.99445 15.5 9.36719C15.0001 10.4283 14.5001 14.514 14.5 16H9.5C9.49994 14.514 8.99994 10.4283 8.5 9.36719C8.32611 8.99809 8.06122 8.43079 8.01074 7.54395C8.00427 7.44528 8 7.34552 8 7.24512C8.00012 4.90083 9.79106 3 12 3Z"
                stroke={color} strokeWidth="2"/>
        </svg>
    );
}

export default StampLine;
